<template>
  <CollapsableSection
    v-for="(accordion, index) in accordions"
    :key="index"
    class="bg-white"
    section-classes="w-full text-xs text-gray-800 border-b border-gray-200 border-solid last:border-0"
    title-classes="lg:text-xl"
    collapsable-padding="px-6 py-2 lg:px-8 lg:py-4"
    collapsable-content-classes="px-6 py-2 lg:px-8 lg:py-4"
    :title="accordion.fields.title"
    :is-open="accordion.isOpen"
    @update:open="accordion.isOpen = $event"
  >
    <TextBlock :content="accordion" />
  </CollapsableSection>
</template>

<script setup lang="ts">
import type { TextBlockRestAPI } from '@/types/contentful';
type TextBlock = TextBlockRestAPI & {
  isOpen: boolean;
};

type Accordions = {
  fields: {
    accordions: TextBlock[];
  };
};

type Props = {
  content?: Accordions;
};

const props = withDefaults(defineProps<Props>(), {
  content: undefined,
});

const accordions = ref<TextBlock[]>(
  (props.content?.fields?.accordions || []).map((accordion) => ({
    ...accordion,
    isOpen: false,
  })),
);

defineEmits<{
  (e: 'error'): void;
}>();
</script>

<script lang="ts">
export default defineComponent({
  name: 'AccordionsContainer',
});
</script>
